import ContractsAdmin from "../../views/adminView/contractsView/adminContractsView";

export default function AdminContractsViewPage() {
    return <ContractsAdmin />
}